var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"main-layout"}},[_c('div',{staticClass:"main-header"},[_c('HeaderLayout')],1),_c('div',{staticClass:"main-box"},[_c('keep-alive',[_c('router-view')],1)],1),_c('div',{staticClass:"main-footer"},[_c('FooterLayout')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }